import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { LocalStorageService } from './../services/local-storage.service';
import { CompanyService } from './company.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';


@Injectable()
export class CompanyGuard {

  constructor(
    private companyService: CompanyService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private _authGuard: AuthGuard
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean | Promise<boolean> {
    return this._authGuard.canActivate(route, state).then((auth: boolean) => {
      if (!auth) {
        this.router.navigate(['/login']);
        return Promise.resolve(false);
      }
      const company = this.localStorageService.get('company');
      if (company == null) {
        this.companyService.selectedCompany = null;
        this.router.navigateByUrl('/company/select');
        return Promise.resolve(false);
      }
      return new Promise((response, error) => {
        this.companyService.getCompany(company).subscribe(
          (data) => {
            if (typeof data === 'undefined') {
              this.companyService.selectedCompany = undefined;
              this.router.navigateByUrl('/company/select');
              return response(false);
            }
            this.companyService.selectedCompany = data;
            return response(true);
          },
          (err) => {
            // this.localStorageService.set('company', null);
            this.companyService.selectedCompany = undefined;
            this.router.navigateByUrl('/company/select');
            return response(false);
          }
        );
      });
    }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/services/company.guard.ts